import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';

import { StyledListItemContainer, StyledListItemProduct, StyledListItemProductLink, StyledListItemName, StyledListItemPrice } from './ProductAddOnListItemStyles';

var ProductAddOnListItem = function ProductAddOnListItem(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var handleClick = function handleClick() {
    setChecked(!checked);
    props.handleSetAddOnListSelectedItems(props.item.item);
  };
  var handleClickTitle = function handleClickTitle() {
    props.setActiveProductForAddOnModal(props.item.item.handle);
  };
  return React.createElement(
    StyledListItemContainer,
    null,
    React.createElement('input', {
      type: 'checkbox',
      defaultChecked: false,
      onChange: function onChange() {
        return handleClick();
      },
      'aria-label': 'Toggle ' + props.item.item.name + ' checkbox'
    }),
    React.createElement(Checkbox, {
      className: 'product-addon-list-item__checkmark',
      checked: checked,
      width: '18px',
      styles: { marginRight: '15px' },
      handleClick: handleClick
    }),
    React.createElement(
      StyledListItemProduct,
      null,
      React.createElement(
        StyledListItemProductLink,
        { className: 'product-addon-list-item__title', onClick: function onClick() {
            return handleClickTitle();
          } },
        React.createElement(
          StyledListItemName,
          null,
          props.item.item.name
        ),
        React.createElement(
          StyledListItemPrice,
          null,
          '$',
          props.item.item.price
        )
      )
    )
  );
};

ProductAddOnListItem.propTypes = {
  item: PropTypes.object,
  handleSetAddOnListSelectedItems: PropTypes.func.isRequired,
  setActiveProductForAddOnModal: PropTypes.func.isRequired
};

export default ProductAddOnListItem;